<div class="container-fluid">

  <!-- HEADER -->
  <div class="row align-items-center mb-3">
    <div class="col-md-6">
      <h2 class="fw-bold mb-0">Profit And Loss</h2>
    </div>

    <div class="col-md-6 text-md-end mt-2 mt-md-0">
      <button
        pButton
        icon="pi pi-refresh"
        label="REFRESH"
        class="btn btn-primary btn-sm me-2"
        (click)="getDetails()">
      </button>

      <button
        pButton
        icon="pi pi-file-excel"
        label="EXPORT TO EXCEL"
        class="btn btn-danger btn-sm"
        (click)="exportExcel()">
      </button>
    </div>
  </div>

  <!-- FILTER CARD -->
  <div class="card shadow-sm mb-4">
    <div class="card-body">

    <div class="row g-3">

      <!-- Date Range -->
      <div class="col-md-4 col-sm-12">
        <div class="form-group">
        <label class="form-label mb-0 fw-semibold">Date range</label>
        <p-calendar
          [(ngModel)]="dateRange"
          selectionMode="range"
          dateFormat="yy-mm-dd"
          inputStyleClass="form-control w-100"
          appendTo="body"
          style="width: 100%">
        </p-calendar>
        </div>


        <!-- Quick Buttons -->
        <!-- <div class="d-flex flex-wrap gap-2 mt-2">
          <button class="btn btn-outline-primary btn-sm" (click)="setDateRange('today')">Today</button>
          <button class="btn btn-outline-primary btn-sm" (click)="setDateRange('7days')">Last 7 Days</button>
          <button class="btn btn-outline-primary btn-sm" (click)="setDateRange('30days')">Last 30 Days</button>
          <button class="btn btn-outline-primary btn-sm" (click)="setDateRange('thisMonth')">This Month</button>
          <button class="btn btn-outline-primary btn-sm" (click)="setDateRange('lastMonth')">Last Month</button>
        </div> -->
      </div>

      <!-- Location -->
      <div class="col-md-4 col-sm-12">
        <div class="form-group">
        <label class="form-label fw-semibold">Location</label>
        <p-multiSelect
          [options]="locations"
          optionLabel="displayName"
          display="chip"
          [(ngModel)]="selectedLocations"
          appendTo="body"
          style="width: 100%"
          class="w-100">
        </p-multiSelect>
        </div>
      </div>
    </div>

    </div>
  </div>

  <!-- LOADER -->
  <div *ngIf="loading" class="text-center p-4">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>

  <!-- TABLE -->
  <div *ngIf="!loading && profitAndLoss.length">

    <div class="table-responsive">
      <table class="table table-bordered table-hover">

        <thead>
          <tr>
            <th>Account Type</th>
            <th>Code</th>
            <th>Description</th>
            <th *ngFor="let d of headerDates" class="text-center">{{ d }}</th>
          </tr>
        </thead>

        <tbody *ngFor="let group of profitAndLoss">

          <tr class="table-secondary">
            <td [attr.colspan]="3 + headerDates.length">
              <strong>{{ group.accountType }}</strong>
            </td>
          </tr>

          <tr *ngFor="let row of group.items">
            <td></td>
            <td>{{ row.accountCode }}</td>
            <td>{{ row.accountName }}</td>
            <td *ngFor="let amt of row.amounts" class="text-end">
              {{ amt.amount | number:'1.2-2' }}
            </td>
          </tr>

          <tr class="fw-bold">
            <td></td>
            <td></td>
            <td class="text-center">{{ group.description }}</td>

            <td *ngFor="let st of group.journalSubTotalAmounts"
                class="text-end">
              {{ st.amountSubTotal | number:'1.2-2' }}
            </td>
          </tr>

        </tbody>

        <tfoot>
          <tr class="table-dark text-white">
            <td></td>
            <td></td>
            <td class="text-center fw-bold">Net Profit</td>

            <td *ngFor="let np of netProfitAmounts" class="text-end fw-bold">
              {{ np.amountSubTotal | number:'1.2-2' }}
            </td>
          </tr>
        </tfoot>

      </table>
    </div>

  </div>

</div>
